var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Paper",
    d: "M4.674 20A4.7 4.7 0 010 15.29V4.51A4.493 4.493 0 014.465 0h5.287a.458.458 0 01.455.46v3.22a3.341 3.341 0 003.308 3.34c.423 0 .794 0 1.122.006h1.201c.229 0 .486-.005.716-.005A.448.448 0 0117 7.47v8.04A4.473 4.473 0 0112.554 20zm.01-6.359a.756.756 0 00.743.75h5.386a.756.756 0 00.743-.75.742.742 0 00-.743-.741H5.426a.742.742 0 00-.742.74zm0-4.99a.742.742 0 00.743.74h3.345a.742.742 0 00.743-.74.756.756 0 00-.743-.75H5.426a.756.756 0 00-.742.749zm8.964-3.091a2.018 2.018 0 01-2-2.017V.906a.473.473 0 01.814-.334l3.986 4.187a.477.477 0 01-.34.806h-.691c-.624.002-1.268-.001-1.769-.006z"
  })));
}

export default SvgDocumentIcon;